import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/CheckCircle.es.js";
const c = e.forwardRef((o, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...o, weights: a }));
c.displayName = "CheckCircleIcon";
const s = c;
export {
  s as CheckCircle,
  c as CheckCircleIcon
};
